export default {
  SETTINGS_OPERATOR: 'SETTINGS_OPERATOR',
}